import { ChangeEvent } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";

export default function CalculatorInputForm(props: {
  form: any;
  onFormChange: any;
}) {
  const { form, onFormChange } = props;

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const transformedValue =
      e.target.type === "number" && value ? Number(value) : value;

    onFormChange({ name, value: transformedValue });
  };

  const invalidInput = (value: number) => {
    return !value && value !== 0;
  };

  return (
    <Box
      component="form"
      sx={{
        "& .MuiTextField-root": { m: 1, width: "25ch" },
      }}
    >
      <TextField
        size="small"
        id="ticker"
        label="Ticker"
        type="text"
        name="ticker"
        variant="outlined"
        placeholder="Enter a Ticker"
        InputLabelProps={{
          shrink: true,
        }}
        error={!form.ticker}
        value={form.ticker}
        onChange={handleInputChange}
      />
      <TextField
        size="small"
        id="discount-rate"
        label="Discount Rate"
        type="number"
        name="discountRate"
        variant="outlined"
        placeholder="Enter a discount rate"
        InputLabelProps={{
          shrink: true,
        }}
        error={invalidInput(form.discountRate)}
        value={form.discountRate}
        onChange={handleInputChange}
      />
      <TextField
        size="small"
        id="free-cash-flow"
        label="Current Free Cash Flow"
        type="number"
        name="freeCashFlow"
        variant="outlined"
        placeholder="Enter a current free cash flow value"
        InputLabelProps={{
          shrink: true,
        }}
        error={invalidInput(form.freeCashFlow)}
        value={form.freeCashFlow}
        onChange={handleInputChange}
      />
      <TextField
        size="small"
        id="cash"
        label="Cash"
        type="number"
        name="cash"
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
        error={invalidInput(form.cash)}
        value={form.cash}
        onChange={handleInputChange}
      />
      <TextField
        size="small"
        id="exit-multiple"
        label="FCF Exit Multiple"
        type="number"
        name="exitMultiple"
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
        error={invalidInput(form.exitMultiple)}
        value={form.exitMultiple}
        onChange={handleInputChange}
      />
      <TextField
        size="small"
        id="fcf-growth-1"
        label="FCF Growth Rate (Years 1-3)"
        type="number"
        name="fcfGrowthOne"
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
        error={invalidInput(form.fcfGrowthOne)}
        value={form.fcfGrowthOne}
        onChange={handleInputChange}
      />
      <TextField
        size="small"
        id="fcf-growth-2"
        label="FCF Growth Rate (Years 4-6)"
        type="number"
        name="fcfGrowthTwo"
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
        error={invalidInput(form.fcfGrowthTwo)}
        value={form.fcfGrowthTwo}
        onChange={handleInputChange}
      />
      <TextField
        size="small"
        id="fcf-growth-3"
        label="FCF Growth Rate (Years 7-10)"
        type="number"
        name="fcfGrowthThree"
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
        error={invalidInput(form.fcfGrowthThree)}
        value={form.fcfGrowthThree}
        onChange={handleInputChange}
      />
      <TextField
        size="small"
        id="shares"
        label="Shares Outstanding"
        type="number"
        name="shares"
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
        error={invalidInput(form.shares)}
        value={form.shares}
        onChange={handleInputChange}
      />
      <TextField
        size="small"
        id="marketCap"
        label="Current Market Cap"
        type="number"
        name="marketCap"
        variant="outlined"
        InputLabelProps={{
          shrink: true,
        }}
        error={invalidInput(form.marketCap)}
        value={form.marketCap}
        onChange={handleInputChange}
      />
    </Box>
  );
}
